import type { Bruker } from '@klp/user';
import type { IconName } from '@klp/design/Illustrations';
import type { PictogramNameType } from '@klp/design/Illustrations/assets/IconNames';

interface ISidebarMenuItem {
    access?: (user?: Bruker) => boolean;
    condition?: (props: object) => boolean;
    divider?: boolean;
    icon?: IconName;
    matchRoute?: string;
    pictogram?: PictogramNameType;
    route?: string;
    translation?: string;
    callback?: (...param: any) => void;
}

export class SidebarMenuItem implements ISidebarMenuItem {
    public access: ISidebarMenuItem['access'];
    public condition: ISidebarMenuItem['condition'];
    public divider: ISidebarMenuItem['divider'] = false;
    public icon: ISidebarMenuItem['icon'];
    public matchRoute: ISidebarMenuItem['matchRoute'];
    public pictogram: ISidebarMenuItem['pictogram'];
    public route: ISidebarMenuItem['route'];
    public translation: ISidebarMenuItem['translation'];
    public callback: ISidebarMenuItem['callback'];

    public constructor(props: ISidebarMenuItem) {
        Object.assign(this, props);
    }
}
